module.exports = __webpack_public_path__ + "img/wx-qrcode.b2900bf6.jpg";